import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import {
  Button, Tooltip, OverlayTrigger, Modal,
} from 'react-bootstrap';

// Import Selectors
import { getUserCurrentOrganization } from '../../modules/Auth/AuthReducer';
import { getRoles, getRolesLoading, getRolesLoaded } from './reducer';
import { fetchRoles } from './actions';

import ContactForm from './form';

class AddOpportunityContactButton extends Component {
  constructor() {
    super();
    this.state = {
      show: false,
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
  }

  componentDidMount() {
    this.checkProps();
  }

  checkProps() {
    const { rolesLoading, rolesLoaded, organization } = this.props;
    if (!rolesLoading && !rolesLoaded) {
      this.props.dispatch(fetchRoles(organization._id));
    }
  }

  close() {
    this.setState({ show: false });
  }

  open() {
    this.setState({ show: true });
  }

  handleSuccess(contact, error) {
    this.props.onSuccess(contact, error);
    this.close();
  }

  renderModal() {
    const { show } = this.state;
    const {
      opportunity, account, roles, isAccount, organization,
    } = this.props;
    const title = isAccount ? 'Add Account Contact' : 'Add Opportunity Contact';
    const canMakeContactPrimary = organization.feedback_request_settings?.can_make_contact_primary || false;
    return (
      <Modal key="modal" show={show} onHide={this.close}>
        <Modal.Header closeButton>
          <h4>{title}</h4>
        </Modal.Header>
        <Modal.Body>
          <ContactForm
            isAccount={isAccount}
            shouldReset={show}
            onContactAdd={this.handleSuccess}
            opportunity={opportunity}
            account={account}
            roles={roles}
            canMakeContactPrimary={canMakeContactPrimary}
          />
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    const {
      disabled, title, tooltip, organization,
    } = this.props;
    if (organization && organization.is_demo) {
      return null;
    }
    const tip = (
      <Tooltip id="add-contact-button-tip">
        <div>{tooltip}</div>
      </Tooltip>
    );
    return [
      (
        <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
          <Button onClick={this.open} bsStyle="link" disabled={disabled}>
            <span><Fa name="plus" /> {title}</span>
          </Button>
        </OverlayTrigger>
      ),
      this.renderModal(),
    ];
  }
}

AddOpportunityContactButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    is_demo: PropTypes.bool,
    feedback_request_settings: PropTypes.shape({
      can_make_contact_primary: PropTypes.bool,
    }),
  }).isRequired,
  opportunity: PropTypes.shape({
    opportunity_id: PropTypes.string,
    name: PropTypes.string,
  }),
  account: PropTypes.shape({
    account_id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  isAccount: PropTypes.bool,
  disabled: PropTypes.bool,
  title: PropTypes.node,
  tooltip: PropTypes.string,
  onSuccess: PropTypes.func,
  rolesLoading: PropTypes.bool,
  rolesLoaded: PropTypes.bool,
  roles: PropTypes.arrayOf(PropTypes.shape({})),
};
AddOpportunityContactButton.defaultProps = {
  disabled: false,
  title: 'Add Contact',
  isAccount: false,
  tooltip: 'Add Contact',
  onSuccess: () => {},
  rolesLoading: false,
  rolesLoaded: false,
  roles: [],
};
AddOpportunityContactButton.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};
// Retrieve data from store as props
function mapStateToProps(state) {
  const organization = getUserCurrentOrganization(state);
  let roles = [];
  let rolesLoading = false;
  let rolesLoaded = false;
  if (organization) {
    const id = organization._id;
    roles = getRoles(state, id);
    rolesLoading = getRolesLoading(state, id);
    rolesLoaded = getRolesLoaded(state, id);
  }
  return {
    organization,
    roles,
    rolesLoading,
    rolesLoaded,
  };
}
export default connect(mapStateToProps)(AddOpportunityContactButton);
